/**
 * Registro de iconos extensible para el Sidenav
 * Permite registrar iconos personalizados y usar iconos predefinidos
 */

// Iconos predefinidos del sistema
const defaultIcons = {
  // Navegación
  dashboard: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z",
  analytics: "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z",
  reports: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M16 13H8 M16 17H8 M10 9H8",
  settings: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94L15.4 4.5c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L4.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z",
  users: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2 M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z",
  manage: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M9 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z M23 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75",
  pulse: "M22 12h-4l-3 9L9 3l-3 9H2",
  hire: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M12.5 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z M20 8v6 M23 11h-6",
  services: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z",
  help: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3 M12 17h.01",
  
  // Interfaz
  menu: "M3 12h18M3 6h18M3 18h18",
  close: "M18 6L6 18M6 6l12 12",
  chevronRight: "M9 18l6-6-6-6",
  chevronDown: "M6 9l6 6 6-6",
  chevronLeft: "M15 18l-6-6 6-6",
  chevronUp: "M18 15l-6-6-6 6",
  
  // Acciones
  search: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z",
  plus: "M12 5v14m-7-7h14",
  minus: "M5 12h14",
  edit: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
  delete: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16",
  save: "M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z",
  
  // Estados
  check: "M20 6L9 17l-5-5",
  x: "M18 6L6 18M6 6l12 12",
  alert: "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z",
  info: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z",
  
  // Dispositivos
  monitor: "M20 3H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h4l-2 2v1h12v-1l-2-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z",
  mobile: "M17 2H7a2 2 0 00-2 2v16a2 2 0 002 2h10a2 2 0 002-2V4a2 2 0 00-2-2z",
  tablet: "M18 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2z",
  
  // Comunicación
  mail: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z M22 6l-10 7L2 6",
  phone: "M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z",
  message: "M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z",
  
  // Archivos
  file: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6",
  folder: "M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z",
  download: "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3",
  upload: "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12",
  
  // Redes sociales
  github: "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22",
  twitter: "M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z",
  linkedin: "M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z M4 2a2 2 0 100 4 2 2 0 000-4z"
};

class IconRegistry {
  constructor() {
    this.icons = { ...defaultIcons };
    this.aliases = new Map();
    this.categories = new Map();
    
    // Categorizar iconos predefinidos
    this.categorizeDefaultIcons();
  }

  /**
   * Categorizar iconos predefinidos
   */
  categorizeDefaultIcons() {
    const categories = {
      navigation: ['dashboard', 'analytics', 'reports', 'settings', 'users', 'manage', 'pulse', 'hire', 'services', 'help'],
      interface: ['menu', 'close', 'chevronRight', 'chevronDown', 'chevronLeft', 'chevronUp'],
      actions: ['search', 'plus', 'minus', 'edit', 'delete', 'save'],
      states: ['check', 'x', 'alert', 'info'],
      devices: ['monitor', 'mobile', 'tablet'],
      communication: ['mail', 'phone', 'message'],
      files: ['file', 'folder', 'download', 'upload'],
      social: ['github', 'twitter', 'linkedin']
    };

    Object.entries(categories).forEach(([category, iconNames]) => {
      iconNames.forEach(iconName => {
        this.categories.set(iconName, category);
      });
    });
  }

  /**
   * Registrar un nuevo icono
   * @param {string} name - Nombre del icono
   * @param {string} path - Path SVG del icono
   * @param {string} category - Categoría del icono
   * @param {Object} options - Opciones adicionales
   */
  register(name, path, category = 'custom', options = {}) {
    if (typeof name !== 'string' || !name.trim()) {
      throw new Error('Icon name must be a non-empty string');
    }

    if (typeof path !== 'string' || !path.trim()) {
      throw new Error('Icon path must be a non-empty string');
    }

    this.icons[name] = path;
    this.categories.set(name, category);

    // Registrar metadatos adicionales si se proporcionan
    if (options.viewBox) {
      this.icons[`${name}_viewBox`] = options.viewBox;
    }

    if (options.strokeWidth) {
      this.icons[`${name}_strokeWidth`] = options.strokeWidth;
    }

    return this;
  }

  /**
   * Registrar múltiples iconos
   * @param {Object} icons - Objeto con iconos { name: path }
   * @param {string} category - Categoría para todos los iconos
   */
  registerBatch(icons, category = 'custom') {
    Object.entries(icons).forEach(([name, path]) => {
      this.register(name, path, category);
    });
    return this;
  }

  /**
   * Crear alias para un icono existente
   * @param {string} alias - Nombre del alias
   * @param {string} originalName - Nombre del icono original
   */
  createAlias(alias, originalName) {
    if (!this.icons[originalName]) {
      throw new Error(`Original icon "${originalName}" not found`);
    }

    this.aliases.set(alias, originalName);
    return this;
  }

  /**
   * Obtener un icono por nombre
   * @param {string} name - Nombre del icono
   * @returns {string|null} Path SVG del icono
   */
  get(name) {
    // Verificar si es un alias
    const resolvedName = this.aliases.get(name) || name;
    return this.icons[resolvedName] || null;
  }

  /**
   * Verificar si un icono existe
   * @param {string} name - Nombre del icono
   * @returns {boolean}
   */
  has(name) {
    const resolvedName = this.aliases.get(name) || name;
    return !!this.icons[resolvedName];
  }

  /**
   * Obtener todos los iconos de una categoría
   * @param {string} category - Nombre de la categoría
   * @returns {Array} Array de nombres de iconos
   */
  getByCategory(category) {
    const iconNames = [];
    this.categories.forEach((iconCategory, iconName) => {
      if (iconCategory === category) {
        iconNames.push(iconName);
      }
    });
    return iconNames;
  }

  /**
   * Obtener todas las categorías disponibles
   * @returns {Array} Array de nombres de categorías
   */
  getCategories() {
    return [...new Set(this.categories.values())];
  }

  /**
   * Obtener la categoría de un icono
   * @param {string} name - Nombre del icono
   * @returns {string|null} Categoría del icono
   */
  getCategory(name) {
    const resolvedName = this.aliases.get(name) || name;
    return this.categories.get(resolvedName) || null;
  }

  /**
   * Buscar iconos por término
   * @param {string} term - Término de búsqueda
   * @returns {Array} Array de nombres de iconos que coinciden
   */
  search(term) {
    const searchTerm = term.toLowerCase();
    const results = [];

    Object.keys(this.icons).forEach(iconName => {
      if (iconName.toLowerCase().includes(searchTerm)) {
        results.push(iconName);
      }
    });

    // También buscar en aliases
    this.aliases.forEach((originalName, alias) => {
      if (alias.toLowerCase().includes(searchTerm)) {
        results.push(alias);
      }
    });

    return [...new Set(results)];
  }

  /**
   * Obtener todos los iconos disponibles
   * @returns {Array} Array de nombres de iconos
   */
  getAll() {
    const iconNames = Object.keys(this.icons).filter(name => !name.includes('_'));
    const aliasNames = [...this.aliases.keys()];
    return [...new Set([...iconNames, ...aliasNames])];
  }

  /**
   * Eliminar un icono
   * @param {string} name - Nombre del icono
   */
  remove(name) {
    delete this.icons[name];
    this.categories.delete(name);
    
    // Eliminar aliases que apunten a este icono
    this.aliases.forEach((originalName, alias) => {
      if (originalName === name) {
        this.aliases.delete(alias);
      }
    });

    return this;
  }

  /**
   * Limpiar todos los iconos personalizados (mantener predefinidos)
   */
  clearCustom() {
    const customIcons = this.getByCategory('custom');
    customIcons.forEach(iconName => {
      this.remove(iconName);
    });
    return this;
  }

  /**
   * Exportar configuración de iconos
   * @returns {Object} Configuración exportable
   */
  export() {
    return {
      icons: { ...this.icons },
      aliases: Object.fromEntries(this.aliases),
      categories: Object.fromEntries(this.categories)
    };
  }

  /**
   * Importar configuración de iconos
   * @param {Object} config - Configuración a importar
   */
  import(config) {
    if (config.icons) {
      Object.assign(this.icons, config.icons);
    }

    if (config.aliases) {
      Object.entries(config.aliases).forEach(([alias, original]) => {
        this.aliases.set(alias, original);
      });
    }

    if (config.categories) {
      Object.entries(config.categories).forEach(([icon, category]) => {
        this.categories.set(icon, category);
      });
    }

    return this;
  }

  /**
   * Obtener estadísticas del registro
   * @returns {Object} Estadísticas
   */
  getStats() {
    const categories = this.getCategories();
    const stats = {
      totalIcons: Object.keys(this.icons).filter(name => !name.includes('_')).length,
      totalAliases: this.aliases.size,
      categories: categories.length,
      categoryBreakdown: {}
    };

    categories.forEach(category => {
      stats.categoryBreakdown[category] = this.getByCategory(category).length;
    });

    return stats;
  }
}

// Instancia singleton del registro
const iconRegistry = new IconRegistry();

export default iconRegistry;
export { IconRegistry };
